// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

const firebaseConfig = {
  apiKey: "AIzaSyCJAEvgl4pz0-Q77HCHmxvFlunppqRf1iE",
  authDomain: "conference-portal-6fd2f.firebaseapp.com",
  projectId: "conference-portal-6fd2f",
  storageBucket: "conference-portal-6fd2f.appspot.com",
  messagingSenderId: "205727306599",
  appId: "1:205727306599:web:f4fb7927e80d836afe15c2"
};


const app = initializeApp(firebaseConfig);

export default app;